import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fill-height background_image",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "login_card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { class: "login" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "text-center"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: "/img/bobbee_logo_3.png",
                    height: "100vh"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.user && _ctx.user.id)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "align-center text-center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.user.firstname + " " + _ctx.user.lastname), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Votre email a bien été vérifiée", -1)),
                      _createVNode(_component_v_btn_primary, {
                        rounded: "",
                        class: "mt-4",
                        width: "80%",
                        elevation: "0",
                        onClick: _ctx.end,
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode(" Continuer ")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Le lien de vérification a expiré", -1)),
                        _createVNode(_component_router_link, { to: "/" }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("Retourner à la page de connexion")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
        ])
      ]),
      _: 1
    })
  ]))
}